<template>
    <vs-popup class="add-new-incoterms" id="popup" title="SAMPLE ORDERS" @close="open = false" :active.sync="open"
        :buttons-hidden="true">
        <vx-card no-shadow>
            <vs-table :data="data_list">

                <template slot="thead">
                    <vs-th>DATE/TIME</vs-th>
                    <vs-th>ORDER CODE</vs-th>
                    <vs-th>COUNTRY</vs-th>
                    <vs-th>ORDER STATUS</vs-th>
                    <vs-th>ACTION</vs-th>
                </template>

                <template slot-scope="{data}">
                    <vs-tr :key="indextr" v-for="(tr, indextr) in data">

                        <vs-td :data="data[indextr].created_at">
                            {{ __dateTimeFormatter(data[indextr].created_at) }}
                        </vs-td>

                        <vs-td :data="data[indextr].sample_order_code">
                            {{ data[indextr].sample_order_code }}
                        </vs-td>

                        <vs-td :data="data[indextr].country">
                            {{ data[indextr].country }}
                        </vs-td>

                        <vs-td :data="data[indextr].status">
                            <vs-chip>
                                {{ data[indextr].status.name }}
                            </vs-chip>
                        </vs-td>

                        <vs-td>
                            <div class="vx-row">
                                <vx-tooltip class="mr-2" text="VIEW ORDER" position="top" v-can="'view-sample-order'">
                                    <vs-button @click.stop="onClickSampleOrderView(data[indextr].id)" size="small"
                                        color="primary" type="border" icon-pack="feather"
                                        icon="icon-external-link"></vs-button>
                                </vx-tooltip>
                            </div>
                        </vs-td>

                    </vs-tr>
                </template>

            </vs-table>
        </vx-card>
    </vs-popup>
</template>
  
<script>
import { RepositoryFactory } from '@/repository/RepositoryFactory'

const CustomerRepository = RepositoryFactory.get('customer');

import SuccessMessage from '@/mixins/SuccessMessage'
import ErrorMessages from '@/mixins/ErrorMessages'

function initialState() {
    return {
        open: false,
        id: '',
        data_list: [],
    }
}

export default {
    name: 'ViewLeadSampleOrdersPopUp',
    data() {
        return initialState()
    },
    methods: {
        async openPopup(id) {
            try {
                await Object.assign(this.$data, initialState());
                this.open = true;
                this.id = id
                await this.fetchLeadSampleOrders()
            } catch (error) {
                this.convertAndNotifyError(error)
            }
        },
        async fetchLeadSampleOrders() {
            try {
                const { data } = await CustomerRepository.getListOfSamplesForLead(this.id)
                this.data_list = data.data
            } catch (error) {
                this.convertAndNotifyError(error)
            }
        },
        async onClickSampleOrderView(id) {
            let route = this.$router.resolve({ path: `/pages/sample-orders/${id}` });
            window.open(route.href, '_blank');
        }
    },
    mixins: [SuccessMessage, ErrorMessages],
}
</script>
  
<style scoped>
.add-new-incoterms>>>.vs-popup {
    min-height: 30% !important;
    min-width: 70% !important;
}
</style>
  